<template>
  <div class="" id="necessary_hardware">
        <div class="fixed z-50 top-0">
            <Header menuColor="#A51111"/>
        </div>
        <div class="register_content" id="necessary_hardware_content">
            <div class="left_section">
                <div class="left_section_heading">
                    Do you have the necessary hardware?
                </div>
                <div class="left_section_sub_para">
                    Some work-from-home jobs require you to have a computer, Internet connection, smartphone, etc.
                </div>
                <div class="back_button_section">
                    <back-button/>
                </div>
            </div>
            <div class="right_section">
                <steps :step="2"/>
                <div class="input_heading">
                    Which of the following do you have?
                </div>
                <div class="options_wrapper">
                    <multiple-select :options="options" v-on:select="onCheckMultipleSelect"/>
                </div>
                <div class="next_button_section">
                    <next-button :onClick="onClickNext" :active="activateNext"/>
                </div>
            </div>
        </div>
        <Footer :stripped="true"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Steps from '@/components/Steps'
import NextButton from '@/components/NextButton'
import BackButton from '@/components/BackButton'
import MultipleSelect from '@/components/MultipleSelect'
import API from '@/API'

export default {
    name: 'NecessaryHardware',
    components: {
        Header,
        Footer,
        'steps': Steps,
        'next-button': NextButton,
        'back-button': BackButton,
        'multiple-select': MultipleSelect
    },
    data(){
        return{
            options: [],
            optionsSelected: new Array,
            mob: 0,
        }
    },
    computed: {
        activateNext: function(){
            // return true to activate next button else false
            // the button should be enabled only if "Laptop/PC" (mandatory) AND "Broadband" OR "4G" (at least one) are selected
            if(this.optionsSelected.length >= 2 && this.optionsSelected.filter(item=>item===0).length === 1){
                return true
            }else{
                return false
            }
        }
    },
    methods: {
        onClickNext: function(){
            // set infrastructure
            var infrastructure = []
            this.optionsSelected.map((item)=>{
                infrastructure.push(this.options[item])
            })
            // set data
            var data = {
                mobile: parseInt(this.mob),
                infrastructure
            }
            // save the form 
            fetch(API+'/jobseeker/infrastructure',
            {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data) // body data type must match "Content-Type" header
            })
            .then(response => response.json())
            .then(data => {
                if(data.success === true){
                    this.$router.push({path:'/jobseeker_register/educational_qualification', query:{mob: this.mob}})
                }
            })
            .catch((err)=>{
                console.log(err)
            })
            
        },
        onCheckMultipleSelect: function(checked){
            // update optionsSelected based on the checked array
            let customThis = this
            checked.map((item, key)=>{
                // check if the key is already in optionsSelected
                if(customThis.optionsSelected.find(element=>element===key) === undefined && item === true){
                    customThis.optionsSelected.push(key)
                }
                // delete the key if the value become false
                if(customThis.optionsSelected.find(element=>element===key) !== undefined && item === false){
                    customThis.optionsSelected.splice(customThis.optionsSelected.indexOf(key), 1)
                }
            })
        },
        setData: function(options){
            // set options
            this.options = options
        }
    },
    mounted(){
        // scroll back to top when mounted
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        this.$nextTick().then(() => {
            this.mob = this.$route.query.mob
        });
    },
    beforeRouteEnter (to, from, next) {
        // get the options from backend
        fetch(API+'/render/infrastructure')
        .then(response => response.json())
        .then(data => {
            // sort the array based on display order
            data.infrasrtuctures.sort((a,b)=>{
                return a.displayOrder - b.displayOrder
            })
            // extract options
            var options = []
            data.infrasrtuctures.map((item)=>{
                options.push(item.option)
            })
            // render component
            next(vm => {vm.setData(options)})
        })
        .catch((err)=>{
            console.log(err)
        })
        
    }
}
</script>

<style>
#necessary_hardware{
    @apply md:h-screen md:w-screen md:flex md:flex-col md:flex-grow-0 md:flex-shrink-0;
}
.options_wrapper{
    @apply mt-6;
}
.back_button_section{
    @apply hidden;
    @apply sm:block;
}
</style>